import React from "react";
import { observer } from "mobx-react-lite";
import MainUser from "./components/MainUser";
import NewGame from "./components/NewGame";
import useController from "./controller";
import UserGames from "./components/UserGames";
import RemoveGame from "../../modals/RemoveGame";
import Ellipses from "../../components/Ellipses";
import EditProfileForm from "./components/EditProfileForm";
import BaseMobileHeader from "../../components/BaseMobileHeader";
import { useTranslation } from "react-i18next";
import MobileAppDownloadBlock from "../../components/MobileAppDownloadBlock";
import Butterflies from "../../components/Butterflies";
import BurgerMenu from "../../components/BurgerMenu";
import BackButton from "../../components/BackButton";
import "./style.scss";
import { isPWA, isWebView } from "../../utils/helpers";
import GenderNotification from "../../modals/GenderNotification";
import PermissionModal from "../../modals/PermissionModal";
import LoyaltyActions from "./components/LoyaltyActions";
import PointsScale from "./components/PointsScale";

export default observer(function PersonalAccountPage() {
  const {
    user,
    startGame,
    activateEditProfile,
    deactivateEditProfile,
    isEditingActivated,
  } = useController();
  const { t } = useTranslation();
  return (
    <div className="personal-account-page">
      <GenderNotification />
      <PermissionModal />
      <Butterflies
        className="personal-account-page-butterflies"
        countEllipses={3}
      />
      <Ellipses className="personal-account-page-ellipses" countEllipses={1} />
      <div className="personal-account-page__wrapper">
        <BaseMobileHeader isBurgerMenu isBackBtn />
        <div className="personal-account-page__wrapper__burger">
          <BackButton></BackButton>
          <BurgerMenu />
        </div>
        <div
          className="personal-account-page__title neon-text"
          data-text={t("personal_account")}
        >
          {t("personal_account")}
        </div>
        {isEditingActivated ? (
          <EditProfileForm
            activateEditProfile={activateEditProfile}
            deactivateEditProfile={deactivateEditProfile}
          />
        ) : (
          <>
            <RemoveGame />
            <PointsScale />
            <MainUser user={user} activateEditProfile={activateEditProfile} />
            <UserGames startGame={startGame} />
            <LoyaltyActions />
            <NewGame />
          </>
        )}
      </div>
      {!isWebView() && !isPWA() ? <MobileAppDownloadBlock /> : null}
    </div>
  );
});
